import React from "react";
import { useBnbSelector } from "../../../redux/store";
import FinancePack from "../common/FinancePack";

const EasyKanzenService = (): JSX.Element => {
    const financePacks = useBnbSelector((state) => state.items.financePacks);

    return (
        <>
            {financePacks.map((pack) => (
                <FinancePack key={pack.id} financePack={pack} />
            ))}
        </>
    );
};

export default EasyKanzenService;
